import _Button from "@material-ui/core/esm/Button";
import _InputBase from "@material-ui/core/esm/InputBase";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { withStyles } from '@material-ui/core/styles';
import { v4 } from 'uuid';
import classnames from 'classnames';
import { PMS2HEX } from 'swag-common/utils/colors';
import styles from './input-pantone-styles';
import CSSclasses from './input-pantone.scss';
import errorAnimationClasses from './error-message.anim.scss';
class InputPantoneComponent extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      value: '',
      errorMessage: null
    });
    _defineProperty(this, "onChange", e => {
      this.setState({
        errorMessage: null,
        value: e.target.value
      });
    });
    _defineProperty(this, "apply", () => {
      const {
        onSubmit,
        shouldValidatePantone = true
      } = this.props;
      const {
        value
      } = this.state;
      const isValueOfColorPantoneValid = InputPantoneComponent.isPantoneValid(value);
      if (!value.trim()) {
        return;
      }
      if (!isValueOfColorPantoneValid && shouldValidatePantone) {
        return this.handleError();
      }
      const colorData = isValueOfColorPantoneValid && {
        id: v4(),
        pms: value,
        hex: `#${PMS2HEX(value)}`
      } || {
        pms: value
      };
      onSubmit(colorData);
      this.setState({
        value: ''
      });
    });
    _defineProperty(this, "handleError", () => {
      this.setState({
        errorMessage: "Sorry, we don't recognize such pantone color"
      });
    });
  }
  static isPantoneValid(val) {
    return PMS2HEX(val) !== '';
  }
  render() {
    const {
      value,
      errorMessage
    } = this.state;
    const {
      className,
      classes,
      isButtonDisabled = false,
      isLimitedEdition
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.row
    }, /*#__PURE__*/React.createElement(_InputBase, {
      className: classes.input,
      placeholder: "Input exact Pantone:",
      value: value,
      onChange: this.onChange,
      "data-input": "Pantone"
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Button, {
      disabled: isButtonDisabled,
      className: classnames(classes.button, {
        [CSSclasses.orangeButton]: isLimitedEdition
      }),
      variant: "contained",
      onClick: this.apply,
      color: "secondary",
      "data-button": "AddColor"
    }, "Add"))), /*#__PURE__*/React.createElement(CSSTransition, {
      classNames: errorAnimationClasses,
      in: !!errorMessage,
      timeout: 500,
      unmountOnExit: true
    }, /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.error
    }, errorMessage)), /*#__PURE__*/React.createElement("div", {
      className: classnames(CSSclasses.findPantoneColor, {
        [CSSclasses.orangeLink]: isLimitedEdition
      })
    }, "Don't know your Pantone color?\xA0", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: "https://swag-prod.s3.us-east-2.amazonaws.com/pantone_color_swatchbook.pdf"
    }, "Find it here.")));
  }
}
export const InputPantone = withStyles(styles)(InputPantoneComponent);